import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M36 90q0-50 64-50t64 50v18q-12-8-24 2l-2-2q-14-8-26 2-12-10-24 0-12-10-26-2l-2 2q-12-10-24-2Z\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"6\" d=\"M56 116q-6 34 4 62M78 116q-8 38-2 66\"></path><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"6\" d=\"M100 116v68\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"6\" d=\"M122 116q8 38 2 66M144 116q6 34-4 62\"></path><ellipse cx=\"84\" cy=\"74\" fill=\"var(--mc-avatar)\" rx=\"6\" ry=\"8\"></ellipse><ellipse cx=\"116\" cy=\"74\" fill=\"var(--mc-avatar)\" rx=\"6\" ry=\"8\"></ellipse>", 6)
  ]))]))
}
export default { render: render }